import { ReactNode } from "react";
import { CoinDozerSymbolEnum } from "./types";
import BigNumber from "bignumber.js";

const CoinDozerUtils = {
  convertSymbol(symbol: number, classNames: string[] = []): ReactNode {
    classNames.push("symbol");
    if (Number.isNaN(symbol)) return "";
    switch (symbol) {
      case CoinDozerSymbolEnum.ZeroCoin:
      case CoinDozerSymbolEnum.OneCoin:
      case CoinDozerSymbolEnum.TwoCoin:
      case CoinDozerSymbolEnum.ThreeCoin:
      case CoinDozerSymbolEnum.DropCoin:
        return (
          <img className={classNames.join(" ")} alt="Coin" src="/cd/0.png" />
        );
      case CoinDozerSymbolEnum.Cherry1:
      case CoinDozerSymbolEnum.Cherry2:
      case CoinDozerSymbolEnum.Cherry3:
        return (
          <img
            className={classNames.join(" ")}
            alt="Cherry"
            src="/cd/201.png"
          />
        );
      case CoinDozerSymbolEnum.Bar1:
      case CoinDozerSymbolEnum.Bar2:
      case CoinDozerSymbolEnum.Bar3:
        return (
          <img className={classNames.join(" ")} alt="Bar" src="/cd/301.png" />
        );
      case CoinDozerSymbolEnum.X2Coin1:
      case CoinDozerSymbolEnum.X2Coin2:
      case CoinDozerSymbolEnum.X2Coin3:
      case CoinDozerSymbolEnum.X2Coin4:
      case CoinDozerSymbolEnum.X2Coin5:
      case CoinDozerSymbolEnum.X2Coin6:
        return (
          <img
            className={classNames.join(" ")}
            alt="X2Coin"
            src="/cd/621.png"
          />
        );
      case CoinDozerSymbolEnum.X3Coin1:
      case CoinDozerSymbolEnum.X3Coin2:
      case CoinDozerSymbolEnum.X3Coin3:
      case CoinDozerSymbolEnum.X3Coin4:
      case CoinDozerSymbolEnum.X3Coin5:
      case CoinDozerSymbolEnum.X3Coin6:
        return (
          <img
            className={classNames.join(" ")}
            alt="X3Coin"
            src="/cd/631.png"
          />
        );
      case CoinDozerSymbolEnum.SevenBedazzle:
        return (
          <img
            className={classNames.join(" ")}
            alt="SevenBedazzle"
            src="/cd/401.png"
          />
        );
      case CoinDozerSymbolEnum.Ring:
        return (
          <img className={classNames.join(" ")} alt="Ring" src="/cd/402.png" />
        );
      case CoinDozerSymbolEnum.Watch:
        return (
          <img className={classNames.join(" ")} alt="Watch" src="/cd/403.png" />
        );
      case CoinDozerSymbolEnum.Phone:
        return (
          <img className={classNames.join(" ")} alt="Phone" src="/cd/404.png" />
        );
      case CoinDozerSymbolEnum.Crown:
        return (
          <img className={classNames.join(" ")} alt="Crown" src="/cd/405.png" />
        );
      case CoinDozerSymbolEnum.FeatureWallAndThrow:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeatureWallAndThrow"
            src="/cd/501.png"
          />
        );
      case CoinDozerSymbolEnum.FeatureRoulette:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeatureRoulette"
            src="/cd/502.png"
          />
        );
      case CoinDozerSymbolEnum.FeaturePushCoins:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeaturePushCoins"
            src="/cd/503.png"
          />
        );
      case CoinDozerSymbolEnum.FeatureThreeBall:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeatureThreeBall"
            src="/cd/504.png"
          />
        );
      case CoinDozerSymbolEnum.FeatureThrowCoins:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeatureThrowCoins"
            src="/cd/505.png"
          />
        );
      case CoinDozerSymbolEnum.FeatureLuckyBonus:
        return (
          <img
            className={classNames.join(" ")}
            alt="FeatureLuckyBonus"
            src="/cd/506.png"
          />
        );
      default:
        return symbol;
    }
  },
  GetSymbols: () => {
    return [
      ["101", [1]],
      ["621", [2]],
      ["631", [3]],
      ["201", [5]],
      ["301", [10]],
      ["401", [15]],
      ["402", [20]],
      ["403", [30]],
      ["404", [40]],
      ["405", [50]],
      ["503", [30, 180]],
      ["501", [15, 190]],
      ["505", [5, 200]],
      ["502", [20, 1000]],
      ["506", [5, 1000]],
    ] as [string, number[]][];
  },
  maxBetFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount);
  },
  maxPayoutFormular(amount: number | BigNumber): BigNumber {
    return BigNumber(amount).multipliedBy(1000); // symbol payout
  },
} as const;

export default CoinDozerUtils;
